<template>
  <v-container fluid class="py-0 fill-height">
    <v-row class="fill-height">
      <v-col cols="12" class="px-0 py-0">
        <v-card height="100%">
          <v-toolbar
              color="indigo"
              dense
              dark>
            <v-toolbar-title>
              {{
                $vuetify.lang.t(datasetEntry.isEmpty ? `$vuetify.criticalDataset.titleNew` :
                    `$vuetify.criticalDataset.titleOld`)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-container fluid>
            <v-card flat>
              <v-card-text class="py-0">
                <critical-dataset-form
                    :dataset-entry="datasetEntry"
                    :user="user"
                    :trip-start="tripStart"
                    :timestamp="timestamp"
                    :critical-slides-loaded="criticalSlidesLoaded"
                    :critical-slides-failed="criticalSlidesFailed">
                </critical-dataset-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text
                       color="success"
                       @click="sendProcessRequest">
                  {{ $vuetify.lang.t(`$vuetify.criticalDataset.buttons.send`) }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CriticalDatasetLabels } from '../../../enum'
import { mdiClose } from '@mdi/js'
import { CriticalDatasetEntry } from '../../../models/criticalDataset/CriticalDatasetEntry'
import CriticalDatasetForm from './CriticalDatasetForm'

const closeIcon = mdiClose

export default {
  name: 'criticalDatasetStepper',
  components: { CriticalDatasetForm },
  props: {
    criticalSlidesLoaded: Boolean,
    criticalSlidesFailed: Boolean,
    datasetEntry: CriticalDatasetEntry,
    user: Number,
    tripStart: Number,
    timestamp: Number
  },
  data: () => ({
    step: 1,
    maximum: 4,

    closeIcon: closeIcon
  }),
  methods: {
    sendProcessRequest () {
      this.$emit('critical-dataset-process-request')
    },
    resetStepper () {
      this.step = 1
    }
  },
  created () {
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  },
}
</script>

<style scoped>

</style>
